import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { RecoveryFlowService } from '../services/recovery-flow/recovery-flow.service';

/**
 * Activates "MFA recovery in progress" mode synchronously, before
 * Angular instantiates the `RecoverMfa` component.
 *
 * Why a guard rather than the component constructor? `app.html` gates
 * the bare-outlet branch on `recoveryFlow.active()`. If the flag is
 * flipped inside the component constructor, the outlet that the
 * component is currently mounting into (e.g. the final unauthenticated
 * `@else { <router-outlet> }`) goes away when the template
 * re-evaluates, taking the freshly-constructed component with it —
 * exactly the destroy-and-remount loop the flag is meant to prevent.
 * Setting it in `canActivate` makes sure the bare-outlet branch is
 * already the active one by the time the component is instantiated.
 *
 * Paired with `RecoverMfa.ngOnDestroy` (which calls
 * `RecoveryFlowService.end()`), so the flag is symmetric across the
 * route's full lifecycle.
 */
export const recoveryFlowGuard: CanActivateFn = () => {
  inject(RecoveryFlowService).begin();
  return true;
};
